<!-- 底部导航 -->
<template>
    <div class="pop-div" v-if="popValue26 && newFormData.type == 26">
        <div
            class="bg-div"
            :style="{
                backgroundColor: newFormData.content.bg_color,
                backgroundImage: `url(${newFormData.content.bg_img.picview})`,
            }"
        >
            <div style="padding: 12px;font-size: 12px;">其他服务</div>
            <div class="overflow-hidden">
                <div
                    class="icon-div"
                    v-for="(item, index) of newFormData.content.iconList2"
                    :key="index"
                >
                    <img :src="item.img_list.picview" class="wh24" />
                    <div
                        class="txt-container"
                        :style="`color: ${newFormData.content.txt_color};`"
                    >
                        {{ item.txt }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        newFormData: {
            type: Object,
            default: {},
        },
        popValue26: {
            type: Boolean,
            default: false,
        },
        showMask: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {};
    },
    mounted() {},
    methods: {
        closePop() {
            this.$emit("update:popValue26", false);
            this.$emit("update:showMask", false);
        },
    },
};
</script>

<style scoped>
.pop-div {
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    z-index: 1000;
    background-color: gray;
}
.bg-div {
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
}
.icon-div {
    margin: 12px 0;
    width: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}
.wh24 {
    width: 24px;
    height: 24px;
}
.overflow-hidden {
    overflow: hidden;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.txt-container {
    margin-top: 3px;
    font-size: 13px;
}
</style>